import React, { useState, useEffect, useCallback, Fragment, useContext } from 'react';
import { Row, Col, Button, OverlayTrigger, Tooltip /*, Spinner*/ } from 'react-bootstrap';
import { createApplicationEconomicFrameworkValue, getApplicationEconomicFrameworkValues } from '@lib/api';
import { Message } from 'primereact';
import StatusBar from 'components/StatusBar';
import EconomicFrameworkOverview from './EconomicFrameworkOverview';
import EconomicFrameworkCompanies from './EconomicFrameworkCompanies';
import { Loading } from '@components/atomic/atoms';
import { UserContext } from '@components/contexts/UserProvider';

const itemNames = {
	indirectCosts: { label: 'Indirect costs', position: 0, isAtotal: false },
	totalEligibleCosts: { label: 'Total eligible costs', position: 1, isAtotal: true },
	fundingRate: { label: 'Funding Rate (%)', position: 2, isAtotal: false },
	maximumEuContribution: { label: 'Maximum EU contribution to eligible costs', position: 3, isAtotal: true },
	requestedEuContribution: { label: 'Requested EU contribution to eligible costs', position: 4, isAtotal: false },
	maxGrantAmount: { label: 'Max grant amount', position: 5, isAtotal: true },
	incomeGenerated: { label: 'Income generated by the action', position: 6, isAtotal: false },
	financialContribution: { label: 'Financial contribution', position: 7, isAtotal: false },
	otherFundingSources: { label: 'Other sources of funding', position: 8, isAtotal: false },
	ownResources: { label: 'Own resources', position: 9, isAtotal: false },
	totalEstimatedIncome: { label: 'Total estimated income', position: 10, isAtotal: true },
	ikaaContribution: { label: 'IKAA (In-Kind Contributions to Additional Activities)', position: 11, isAtotal: false },
};

const EconomicFrameworkWp = ({ projectId, isOe, isExternalAdmin, isThereWp, localLang, myUserCompanies = [], isAboveGuest }) => {
	const { isPartnerUser } = useContext(UserContext);
	const [economicsFramValues, setEconomicsFramValues] = useState(null);
	const [isRefresh, setIsRefresh] = useState(false);
	const [sbShow, setSbShow] = useState(<></>);

	const handleStatusBar = (status, message, timeout) => {
		setSbShow(<StatusBar status={status} message={message} timeout={timeout} />);
	};

	const fetchProjectFrameworks = useCallback(async () => {
		if (projectId) {
			getApplicationEconomicFrameworkValues(projectId).then((retrievedValues) => {
				if (retrievedValues.success) {
					setEconomicsFramValues(retrievedValues.data);
				}
			});
		}
	}, [projectId]);

	useEffect(() => {
		fetchProjectFrameworks();
	}, [fetchProjectFrameworks]);

	const createNewEconomicFramework = async () => {
		const result = await createApplicationEconomicFrameworkValue(projectId);

		if (result.success) {
			handleStatusBar('success', `Quadro economico generato con successo`, true);

			fetchProjectFrameworks();
		} else {
			handleStatusBar('error', `Non è stato possibile generare il quadro economico`, false);
		}
	};

	const ConditionalWrapper = ({ condition, wrapper, children }) => (condition ? wrapper(children) : children);

	const EconomicsSection = () => {
		return (
			<>
				{isPartnerUser ? (
					<EconomicFrameworkOverview projectId={projectId} itemNames={itemNames} isRefresh={isRefresh} setIsRefresh={setIsRefresh} />
				) : null}

				<EconomicFrameworkCompanies
					projectId={projectId}
					itemNames={itemNames}
					isAboveGuest={isAboveGuest}
					isEnabledToView={isOe || isExternalAdmin}
					myUserCompanies={myUserCompanies}
					localLang={localLang}
					economicsFramValues1={economicsFramValues}
					setIsRefresh={setIsRefresh}
				/>
			</>
		);
	};

	return (
		<>
			{economicsFramValues ? (
				economicsFramValues.length === 0 ? (
					<>
						<Message
							severity="warn"
							text="Non hai ancora creato un quadro economico. Dopo aver creato il quadro economico non sarà possibile modificare streams e sotto voci di spesa"
						/>

						{(isOe || isExternalAdmin) && (
							<Row className="mt-5 mb-4">
								<Col className="text-center">
									<ConditionalWrapper
										condition={!isThereWp}
										wrapper={(children) => (
											<OverlayTrigger placement="top" overlay={<Tooltip>Non sono stati ancora creati dei workplan sul progetto</Tooltip>}>
												{children}
											</OverlayTrigger>
										)}
									>
										<span className="d-inline-block" style={{ margin: '4rem auto' }}>
											<Button onClick={createNewEconomicFramework} disabled={!isThereWp}>
												Crea nuovo quadro economico
											</Button>
										</span>
									</ConditionalWrapper>
								</Col>
							</Row>
						)}
					</>
				) : (
					<EconomicsSection />
				)
			) : (
				<Loading fixedHeight="50vh" />
			)}

			{sbShow}
		</>
	);
};
export default EconomicFrameworkWp;
